// extracted by mini-css-extract-plugin
export default {"header":"TableScrollArea_header__UMCcB","scrolled":"TableScrollArea_scrolled__GhKRD"};